import { ISiteDesign } from './../models/IApiResponses'
import {
    ACTION_ADD_NOTIFICATION,
    ACTION_CHEK_AUTH,
    ACTION_DELETE_NOTIFICATION,
    ACTION_SET_ADMIN_AUTH,
    ACTION_SET_DOWNLOAD_URLS,
    ACTION_SET_GUEST_AUTH,
    ACTION_SET_GUEST_USER,
    ACTION_SET_LOADING,
    ACTION_SET_ORG,
    ACTION_SET_SITE_DESIGNS,
    ACTION_SET_USER,
    ACTION_SET_USER_REQUEST_LOADING
} from '../utils/reduxConsts'
import { get_org, guest_login, login } from '../services/api'
import { IGuestUser, INotification } from '../models/IState'
import { IDownloadUrls } from '../models/IApiResponses'

export function setAuth(payload: boolean) {
    if (!payload) {
        localStorage.removeItem('adminToken')
    }
    return {
        type: ACTION_SET_ADMIN_AUTH,
        payload
    }
}

export function setGuestAuth(payload: boolean) {
    if (!payload) {
        localStorage.removeItem('guestToken')
        localStorage.removeItem('phone')
        localStorage.removeItem('isExsistingUser')
        localStorage.removeItem('utm_source');
        localStorage.removeItem('utm_tag');
        window.location.pathname = '/'
    }
    return {
        type: ACTION_SET_GUEST_AUTH,
        payload
    }
}

export function setDownloadURLs(payload: IDownloadUrls) {
    return {
        type: ACTION_SET_DOWNLOAD_URLS,
        payload
    }
}

export function setLoading(payload: boolean) {
    return {
        type: ACTION_SET_LOADING,
        payload
    }
}

export function setUserRequestLoading(payload: boolean) {
    return {
        type: ACTION_SET_USER_REQUEST_LOADING,
        payload
    }
}

export function checkAuth(username: string, password: string) {
    return async (dispatch: any) => {
        dispatch(setLoading(true))
        try {
            const response = await login(username, password)
            if (response.status === 200) {
                localStorage.setItem('adminToken', response.data.access)
                localStorage.setItem('refresh', response.data.refresh)
                dispatch(getOrg())
                dispatch(setAuth(true))
            }
        } catch (e) {
            console.log(e)
        } finally {
            dispatch(setLoading(false))
        }
        dispatch({
            type: ACTION_CHEK_AUTH
        })
    }
}

export function guestAuth(
  phone: string,
  captchaToken?: string,
  telegramCodeToken?: string
) {
  return async (dispatch: any) => {
    // Берём UTM ТОЛЬКО из localStorage
    const utmSource = localStorage.getItem('utm_source');
    const utmTag = localStorage.getItem('utm_tag');

    console.log('[guestAuth] UTM from localStorage:', {
      utmSource,
      utmTag,
    });

    dispatch(setUserRequestLoading(true));

    try {
      const response = await guest_login(
        phone,
        utmSource,
        utmTag,
        captchaToken,
        telegramCodeToken
      ).finally(() => {
        dispatch(setUserRequestLoading(false));
      });

      if (response.status === 200 && response.data && 'token' in response.data) {
        localStorage.setItem('guestToken', response.data.token);
        localStorage.setItem('phone', phone);
        localStorage.setItem('isExsistingUser', 'true');

        dispatch(setDownloadURLs(response.data.download_urls));
        dispatch(setGuestAuth(true));
      }
    } catch (e: any) {
      const status = e?.response?.status;
      const hasTokenIn404 =
        status === 404 && e?.response?.data && 'token' in e.response.data;

      if (!localStorage.getItem('guestToken') && hasTokenIn404) {
        localStorage.setItem('guestToken', e.response.data.token);
        localStorage.setItem('phone', phone);

        // Формируем URL регистрации из localStorage
        const params = new URLSearchParams();
        if (utmSource) params.set('utm_source', utmSource);
        if (utmTag) params.set('utm_tag', utmTag);

        const registerUrl = params.toString()
          ? `/register?${params.toString()}`
          : '/register';

        console.log('[guestAuth] Redirect to:', registerUrl);

        // небольшая задержка (если нужна)
        await new Promise((resolve) => setTimeout(resolve, 1000));

        window.location.assign(registerUrl);
        return;
      }

      dispatch(setUserRequestLoading(false));
    }
  };
}

export function getOrg() {
    return async (dispatch: any) => {
        dispatch(setLoading(true))
        try {
            const response = await get_org()
            if (response.status === 200) {
                dispatch(setAuth(true))
                dispatch({
                    type: ACTION_SET_USER,
                    payload: response.data[0].legal_entity
                })
                dispatch({
                    type: ACTION_SET_ORG,
                    payload: response.data[0]
                })
            }
        } catch (e) {
            console.log(e)
        } finally {
            dispatch(setLoading(false))
        }
    }
}

export function addNotification(payload: INotification) {
    return {
        type: ACTION_ADD_NOTIFICATION,
        payload
    }
}

export function deleteNotification(id: string) {
    return {
        type: ACTION_DELETE_NOTIFICATION,
        id
    }
}

export function setGuestUser(payload: IGuestUser) {
    return {
        type: ACTION_SET_GUEST_USER,
        payload
    }
}

export function setSiteDesigns(payload: ISiteDesign) {
    return {
        type: ACTION_SET_SITE_DESIGNS,
        payload
    }
}
